/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface LoginResponseUserBody
 */
export interface LoginResponseUserBody {
    /**
     * 
     * @type {UserDto}
     * @memberof LoginResponseUserBody
     */
    user: UserDto;
    /**
     * 
     * @type {Date}
     * @memberof LoginResponseUserBody
     */
    tokenExpires: Date;
}

/**
 * Check if a given object implements the LoginResponseUserBody interface.
 */
export function instanceOfLoginResponseUserBody(value: object): value is LoginResponseUserBody {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('tokenExpires' in value) || value['tokenExpires'] === undefined) return false;
    return true;
}

export function LoginResponseUserBodyFromJSON(json: any): LoginResponseUserBody {
    return LoginResponseUserBodyFromJSONTyped(json, false);
}

export function LoginResponseUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserDtoFromJSON(json['user']),
        'tokenExpires': (new Date(json['tokenExpires'])),
    };
}

export function LoginResponseUserBodyToJSON(json: any): LoginResponseUserBody {
    return LoginResponseUserBodyToJSONTyped(json, false);
}

export function LoginResponseUserBodyToJSONTyped(value?: LoginResponseUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserDtoToJSON(value['user']),
        'tokenExpires': value['tokenExpires'].toISOString(),
    };
}

